let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7BIdz")).then(() => parcelRequire('8ReIo'));